import { Component } from 'react'
import {
  DarkButton,
  NegativeButton,
  PrimaryButton,
  SecondaryButton,
  TertiaryButton,
} from './Button'
import { IButtonProps } from './Button.types'

export class Button extends Component<IButtonProps> {
  static Primary = PrimaryButton

  static Dark = DarkButton

  static Secondary = SecondaryButton

  static Tertiary = TertiaryButton

  static Negative = NegativeButton
}

export * from './Button.types'
